<template>
  <div>
    <div :class="$style.block">
      <div class="row">
        <div class="col-xl-12">
          <div :class="$style.inner">
            <div :class="$style.form">
              
              <center>
                <img src="resources/images/logos/logo.png" width="250" style="object-fit: contain;">
              </center>
              <br/>
              <h4 class="text-uppercase">
                <strong>Restaurar contraseña</strong>
              </h4>
              <a-form class="login-form" @submit.prevent="handleValidate" :form="form">
                <a-form-item label="Correo">
                  <a-input
                    placeholder="Correo"
                    v-decorator="['correo', { initialValue: '', rules: [{ required: true, message: 'Please input your username!' }]}]"
                  >
                    <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25);"/>
                  </a-input>
                </a-form-item>
                <div class="form-actions">
                  <a-button
                    type="primary"
                    htmlType="submit"
                    class="login-form-button"
                    style="width: 100%;"
                  >Enviar correo de recuperacion</a-button>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <router-link  to="/user/login">Inicia sesion</router-link>
                  </div>
                </div>
              </a-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utilities from "@/mixins/utilities.js";
export default {
  mixins: [utilities],
  data: function () {
    return {
      
    }
  },
  methods: {
    
    handleSubmit(value) {
      this.$store.dispatch('FORGOTTEN_PASSWORD', value)
        .then(res => {
          debugger
        })
    }
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
